import { useBrandPlanSchedule, Options as BaseOptions, Data } from 'hooks/queries/schedules/useBrandPlanSchedule'

export interface Options<TQueryFnData extends Data = Data, TData extends Data = Data>
  extends Omit<BaseOptions<TQueryFnData, TData>, 'refetchInterval'> {
  intervalMs?: number
}

export type { Data }

export const usePollPreparingBrandPlanSchedule = <TQueryFnData extends Data = Data, TData extends Data = Data>(
  id: number,
  options?: Options<TQueryFnData, TData>,
) => {
  return useBrandPlanSchedule(id, {
    refetchInterval: (schedule) => {
      const shouldPoll =
        schedule?.is_preparing ||
        schedule?.regenerating_topic ||
        (['pending', 'processing'].includes(schedule?.status || '') && (schedule?.contents || []).length > 0)

      if (!shouldPoll) {
        return false
      }

      return options?.intervalMs || 500
    },
    ...options,
  })
}
